import { Singleton } from 'framework/di';

@Singleton()
export class AsyncHelper {
  requestIdleCallback(cb: (deadline: RequestIdleCallback) => any) {
    if (window.requestIdleCallback) {
      return window.requestIdleCallback(cb);
    } else {
      const start = Date.now();
      return setTimeout(function () {
        cb({
          didTimeout: false,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - start));
          },
        });
      }, 1);
    }
  }
}

interface RequestIdleCallback {
  didTimeout?: boolean;
  timeRemaining?(): DOMHighResTimeStamp;
}
